module.exports = __webpack_public_path__ + "img/93.b3b0f838.jpg";